<script>
import BaseFilter from "./BaseFilter";
import { mapGetters } from "vuex";

// TODO: deselect impossible municipalities based on province select (e.g. Amsterdam should be removed if only Friesland is selected)

export default {
  name: "MunicipalitySearch",
  extends: BaseFilter,
  computed: {
    ...mapGetters({
      options: "municipalities_filtered",
    }),
  },
  data() {
    return {
      placeholder: "Alle gemeenten",
      filtername: "gemeenten",
      type: "gemeenten",
    };
  },
};
</script>
